module.exports = __webpack_public_path__ + "img/compass.cc55de41.svg";